module.exports = __webpack_public_path__ + "assets/202509252035/img/logicalStructureLeft.5802598c.jpg";